import types from './types'
import { Role } from '@/api'
import { MessageBox, Message } from 'element-ui'
import { allRole } from './index'

export default {
  async refresh({ commit }) {
    let roles = await Role.getAll()
    commit(types.REFRESH, roles)
  },

  async add({ commit }, payload) {
    let newRole = await Role.add(payload)
    commit(types.ADD, newRole)
    Message.success('新增岗位成功！')
  },

  async update({ commit, state, dispatch }, payload) {
    let updatedRole = await Role.update(state.currentRole.id, payload)
    commit(types.UPDATE, updatedRole)
    Message.success('修改岗位成功！')
    dispatch('staffs/refresh', undefined, { root: true })
  },

  async moveUp({ commit, state }, moveIndex) {
    let newSort = state.roles.map((role, index) => {
      if (moveIndex - 1 === index) {
        return state.roles[index + 1].id
      } else if (moveIndex === index) {
        return state.roles[index - 1].id
      } else {
        return role.id
      }
    })
    await Role.sort(newSort)
    commit(types.MOVE_UP, moveIndex)
    Message.success('岗位排序成功！')
  },

  async delete({ commit, state, dispatch }) {
    try {
      await Role.delete(state.currentRole.id, false, false)
      commit(types.DELETE, state.currentRole)
      Message.success('删除岗位成功！')
      dispatch('select', allRole)
    } catch (e) {
      if (e.message === 'ROLE_HAS_STAFF') {
        await MessageBox.confirm('该岗位下的员工也将一并删除，确认继续吗？')
        await Role.delete(state.currentRole.id, true)
        commit(types.DELETE, state.currentRole)
        Message.success('删除成功')
      }
    }
  },

  select({ commit, dispatch }, newRole) {
    commit(types.SELECT, newRole)
    dispatch('staffs/roleChange', undefined, { root: true })
  },
}
